import React from 'react';
import { FaCircleNotch } from 'react-icons/fa6';
import './LoadingSpiner.css'; // Importing CSS file for styling, make sure to create this file.

interface LoaderProps {
  size?: number; // You can pass the size as a prop, or it will default to 50
  mode?: 'dark' | 'light'; // You can pass the mode as a prop, or it will default to light
  className?: string; // You can pass the className as a prop, or it will default to an empty string
}

const LoadingSpiner: React.FC<LoaderProps> = ({ size = SPINER_SIZES.small, mode, className}) => {

  let color = 'color-neutral-800 dark:color-neutral-200';
  if(mode === 'dark') {
    color = 'color-neutral-200 dark:color-neutral-800';
  }

  return (
    <div className={`loader-container ${className || ""}`} data-testid="loader-container">
      <FaCircleNotch className={`loader ${color}`} size={size} />
    </div>
  );
};

export default LoadingSpiner;

export const SPINER_SIZES = {
  small: 20,
  medium: 30,
};